import { apiFetch, MOBILE_API } from "./api";

interface SignInResponse {
  success: boolean;
  token: string;
  message?: string;
}

interface BuyerLookupResponse {
  success: boolean;
  data?: {
    user?: { id: number; phoneNumber: string; name?: string };
    addresses?: unknown[];
  };
}

export async function buyerSignIn(phoneNumber: string) {
  return apiFetch<SignInResponse>(`${MOBILE_API}/auth/sign-in`, {
    method: "POST",
    body: { phoneNumber, signupMethod: "phone" },
  });
}

/**
 * Resolve the exact phone number format stored in DB by trying both
 * the full E.164 format (+91XXXXXXXXXX) and the 10-digit format.
 * Returns the stored phone if found, or falls back to the original.
 */
async function resolveStoredPhone(phone10: string): Promise<string> {
  const candidates = [`+91${phone10}`, phone10];
  for (const candidate of candidates) {
    try {
      const res = await apiFetch<BuyerLookupResponse>(
        `${MOBILE_API}/users/mobile/${encodeURIComponent(candidate)}`
      );
      if (res.success && res.data?.user?.phoneNumber) {
        return res.data.user.phoneNumber;
      }
    } catch {
      // not found with this format, try next
    }
  }
  return `+91${phone10}`;
}

export async function buyerLogin(phone10: string): Promise<SignInResponse> {
  const storedPhone = await resolveStoredPhone(phone10);
  return buyerSignIn(storedPhone);
}
